import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentAchievements = ({ achievements }) => {
  const achievementIcons = {
    'raid': 'Swords',
    'quest': 'ScrollText',
    'exploration': 'Map',
    'milestone': 'Trophy',
    'skill': 'Sparkles'
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const achievementDate = new Date(timestamp);
    const diffInHours = Math.floor((now - achievementDate) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays}d ago`;
    return achievementDate?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 lg:p-8 border border-border">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold">
          Recent Achievements
        </h2>
        <Icon name="Award" size={24} color="var(--color-primary)" />
      </div>
      <div className="space-y-3 md:space-y-4">
        {achievements?.length === 0 ? (
          <div className="text-center py-8 md:py-12">
            <Icon name="Trophy" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3" />
            <p className="text-sm md:text-base text-muted-foreground">
              No achievements yet. Start your journey!
            </p>
          </div>
        ) : (
          achievements?.map((achievement, index) => (
            <div 
              key={index}
              className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-muted/50 hover:bg-muted transition-all duration-250"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent/20 flex items-center justify-center flex-shrink-0">
                <Icon 
                  name={achievementIcons?.[achievement?.type] || 'Star'} 
                  size={20}
                  color="var(--color-accent)"
                />
              </div>
              
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium mb-1">
                  {achievement?.title}
                </h3>
                <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
                  {achievement?.description}
                </p>
                <p className="text-xs text-muted-foreground mt-1 md:mt-2">
                  {formatTimeAgo(achievement?.timestamp)}
                </p>
              </div>

              <div className="flex-shrink-0">
                <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-accent/20 text-xs font-medium text-accent-foreground">
                  <Icon name="Plus" size={12} />
                  {achievement?.points}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecentAchievements;